import React from 'react';
import { translate } from 'react-i18next';

import ShiftDetailBlock from 'components/ScheduleSidebar/ShiftDetailBlock.js';
import UIStatusDialog from 'components/UIStatusDialog.js';
import EmployeeActions from 'actions/EmployeeActions.js';

class SidebarDropOffer extends React.Component {
  constructor(props) {
    super(props);

    this.onDropOffer = this.onDropOffer.bind(this);
    this.onBidError = this.onBidError.bind(this);
    this.state = {
      status: {},
    };
  }

  componentDidMount() {
    BidsStore.on(
      'exchanges:post:bid:drop:success',
      function (collection, response) {
        this.props.shiftData.bids.push(response.id);
      },
      this,
    );
  }

  componentWillUnmount() {
    this.setState({
      status: {},
    });
    BidsStore.off(null, null, this);
  }

  onDropOffer(e) {
    if (EmployeeActions) {
      EmployeeActions.bidOnDroppedShift(this.props.shiftData.shift_id, this.props.shiftData.id);
      ExchangesStore.on('bid:dropped:error', this.onBidError);
    }
    e.stopPropagation();
  }

  onCancelOffer(e) {
    if (EmployeeActions) {
      const exchange = ExchangesStore.getExchangeByShiftId(
        e.currentTarget.getAttribute('data-shift-id'),
      );

      if (!Utils.isNotDefined(exchange)) {
        EmployeeActions.cancelExchangeOffer(exchange.id);
      }
    }
    e.stopPropagation();
  }

  onBidError(message) {
    const status = { title: this.props.t('SidebarDropOffer.error'), message: message.error_message, status: 'error' };
    this.setState({
      status,
    });
  }

  render() {
    let startTime = '';
    let endTime = '';
    let breaks = null;
    let shift_notes = null;
    let exchange_notes = null;
    if (this.props.active && !Utils.isNotDefined(this.props.shiftData)) {
      startTime = moment(this.props.shiftData.shift_details.start_time)
        .tz(this.props.shiftData.shift_details.time_zone)
        .format('h:mm a');
      endTime = moment(this.props.shiftData.shift_details.end_time)
        .tz(this.props.shiftData.shift_details.time_zone)
        .format('h:mm a');
      var userName = ExchangesStore.getExchangeUser(this.props.shiftData.user_id);
      var hideEnd = this.props.shiftData.shift_details.hide_end_time;

      if (
        !Utils.isNotDefined(this.props.shiftData.shift_details)
        && !Utils.isNotDefined(this.props.shiftData.shift_details.breaks)
      ) {
        breaks = Utils.formatUnformattedBreaks(this.props.shiftData.shift_details.breaks);
      }

      if (
        !Utils.isNotDefined(this.props.shiftData)
        && !Utils.isNotDefined(this.props.shiftData.shift_details)
        && !Utils.isNotDefined(this.props.shiftData.shift_details.shift_notes)
      ) {
        shift_notes = this.props.shiftData.shift_details.shift_notes;
      }

      if (
        !Utils.isNotDefined(this.props.shiftData)
        && !Utils.isNotDefined(this.props.shiftData.notes)
      ) {
        exchange_notes = this.props.shiftData.notes;
      }
    }
    const departID = this.props.shiftData && this.props.shiftData.shift_details
      ? this.props.shiftData.shift_details.department_id
      : '';
    const locID = this.props.shiftData && this.props.shiftData.shift_details
      ? this.props.shiftData.shift_details.location_id
      : '';
    const posID = this.props.shiftData && this.props.shiftData.shift_details
      ? this.props.shiftData.shift_details.position
      : '';
    const job_site_name = this.props.shiftData && this.props.shiftData.shift_details
      ? this.props.shiftData.shift_details.job_site_name
      : '';
    const job_site_address = this.props.shiftData && this.props.shiftData.shift_details
      ? this.props.shiftData.shift_details.job_site_address
      : '';

    let details = null;
    if (!Utils.isNotDefined(departID)) {
      details = (
        <ShiftDetailBlock
          departmentID={departID}
          locationID={locID}
          position={posID}
          job_site_name={job_site_name}
          job_site_address={job_site_address}
        />
      );
    }

    let offerButtonClasses = 'calendar-input-button shift-drop-offer-button';
    if (
      this.props.active
      && !Utils.isNotDefined(this.props.shiftData)
      && BidsStore.iHazBidz(this.props.shiftData)
    ) {
      offerButtonClasses += ' hide';
    }

    let cancelButtonClasses = 'calendar-input-button shift-drop-cancel-button';
    if (
      this.props.active
      && !Utils.isNotDefined(this.props.shiftData)
      && !BidsStore.iHazBidz(this.props.shiftData)
    ) {
      cancelButtonClasses += ' hide';
    } else if (
      this.props.active
      && !Utils.isNotDefined(this.props.shiftData)
      && BidsStore.iHazBidz(this.props.shiftData)
      && this.props.shiftData.state == 'accepted'
    ) {
      cancelButtonClasses += ' hide';
    }

    let pendingButtonClasses = 'calendar-input-button shift-drop-pending-button disabled';
    if (!Utils.isNotDefined(this.props.shiftData) && this.props.shiftData.state != 'accepted') {
      pendingButtonClasses += ' hide';
    }

    let shiftDate = '';
    if (this.props.shiftData && this.props.shiftData.shift_details) {
      const momentObj = moment(this.props.shiftData.shift_details.start_time)
        .tz(this.props.shiftData.shift_details.time_zone);
      shiftDate = Utils.formatLocaleDate(momentObj);
    }

    const classes = `calendar-input exchange-offer ${!this.props.active ? 'hide' : ''}`;
    return (
      <div className={classes}>
        <span className="calendar-input-bullet exchange">{this.props.t('SidebarDropOffer.drop_post')}</span>
        <div className="shift-detail-content">
          <p className="shift-detail-title">
            {userName ? userName.name : ''}
            <br />
            {this.props.shiftData && this.props.shiftData.shift_details
              ? this.props.shiftData.shift_details.name
              : ''}
            <br />
            {shiftDate}
            <br />
            {startTime}
            {' – '}
            {!hideEnd ? endTime : this.props.t('SidebarDropOffer.tbd')}
          </p>

          {!Utils.isNotDefined(breaks) && (
            <p className="shift-detail-breaks">
              {this.props.t('SidebarDropOffer.breaks')}:&nbsp;
              {breaks}
            </p>
          )}

          {details}

          {!Utils.isNotDefined(shift_notes) && (
            <div className="shift-detail-notes-container">
              <p className="shift-detail-title">{this.props.t('SidebarDropOffer.notes').toUpperCase()}</p>
              <p className="shift-detail-notes">{shift_notes}</p>
            </div>
          )}

          {!Utils.isNotDefined(exchange_notes) && (
            <div className="exchange-shift-detail-notes-container">
              <p className="exchange-shift-detail-title">{this.props.t('SidebarDropOffer.exchange_notes').toUpperCase()}</p>
              <p className="exchange-shift-detail-notes">{exchange_notes}</p>
            </div>
          )}
        </div>
        <div className="full-flex-container exchange-buttons">
          <button
            className={offerButtonClasses}
            data-shift-id={this.props.shiftData ? this.props.shiftData.id : null}
            onClick={this.onDropOffer}
          >
            {this.props.t('SidebarDropOffer.offer_to_pick_up')}
          </button>
          <button
            className={cancelButtonClasses}
            data-shift-id={this.props.shiftData ? this.props.shiftData.shift_id : null}
            onClick={this.onCancelOffer}
          >
            {this.props.t('SidebarDropOffer.cancel_offers')}
          </button>
          <button className={pendingButtonClasses}>{this.props.t('SidebarDropOffer.pending_manager_approval')}</button>
        </div>
        <UIStatusDialog status={this.state.status} />
      </div>
    );
  }
}

export default translate()(SidebarDropOffer);
